(ns dashboard.views.policy.config
  (:require
   [reitit.frontend.easy :as rfe]))

(def view-id :route.view/policies)

(defn breadcrumbs []
  [{:href (rfe/href :route.view/home)
    :label "Dashboard"}
   {:href (rfe/href view-id)
    :label "Documents"
    :active? true}])
